<app-header-style-two></app-header-style-two>

<div class="page-title-area">
    <div class="container">
        <h1>Google Reviews – Staten Driving School</h1>
    </div>
</div>

<div class="google-review-area pb-100 pt-100">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="review-content text-center">
                    <div class="review-icon mb-4">
                        <i class="bx bxl-google"></i>
                    </div>
                    <h2 class="mb-4" style="color:rgb(60, 56, 113) !important;">Help Us Improve!</h2>
                    <p class="mb-5">
                        Your feedback is invaluable to us. Please take a moment to share your experience 
                        with our driving school on Google. Your review helps other students make informed decisions 
                        and helps us continue providing excellent service.
                    </p>
                    <div class="review-button">
                        <button (click)="openGoogleReview()" class="default-btn">
                            <i class='bx bx-star icon-arrow before'></i>
                            <span class="label">Rate Us on Google</span>
                            <i class="bx bx-star icon-arrow after"></i>
                        </button>
                    </div>
                    <div class="review-note mt-4">
                        <p class="text-muted">
                            <i class="bx bx-info-circle"></i>
                            Clicking the button will open Google Reviews in a new tab
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> 